import { NavLink, useParams,  } from "react-router-dom";
import Layout from "../../components/Layout/Layout";
import { useEffect, useState } from "react";
import DraggAbleComponentView from "./DraggAbleComponentView";


function SeparateTable(){
    const [componentList, setComponentList] = useState([]);
    const [mergeList, setMergeList] = useState([])
    const { id }  = useParams();


    useEffect(()=>{
        const data = localStorage.getItem("componentList")
        if(data){
            setComponentList(JSON.parse(data))
        }
    },[])

    useEffect(()=>{
        const data = localStorage.getItem("mergeTableList")
        if(data){
            setMergeList(JSON.parse(data))
        }
    },[])

    function separate(data){
        let newList = []
        let newMList = []
            
        componentList.map((item)=>{
            if(data?.mergeId.includes(item?.id)){
                newList = [...newList, {...item, mergedComponent:[], mergedName:"", isMerged:false}]
            }else{
                newList = [...newList, item]
            }
        })

        setComponentList(newList)
        localStorage.setItem("componentList", JSON.stringify(newList));

        newMList = mergeList.filter((mList)=>{
            return(mList?.id != data?.id)
        })

        localStorage.setItem("mergeTableList", JSON.stringify(newMList));

    }


    return(
        <div className=" w-screen h-screen bg-color1">
            <Layout>
                <div className=" w-full h-full mt-1 flex">
                    <div className=" w-[76%] h-full bg-color1 flex flex-col ">
                        <div className=" w-full h-[42px] border-color3 flex ">
                        <div className=" w-[80%] relative ">
                                <NavLink to={"/live-table/"+id} className={(e)=> ` w-[100px] absolute bg-color1 text-color4 text-center p-1 border-color3 border-x border-t ${e.isActive? " h-[42px]":"h-[40px]"} rounded-sm `}>Live Table</NavLink>
                                <NavLink to={"/edit-live-table/"+id} className={(e)=> ` w-[100px] h-[40px] absolute left-[120px] bg-color1 text-color4 text-center p-1 border-color3 border-x border-t ${e.isActive? " h-[42px]":"h-[40px]"} rounded-sm `}>Edit Table</NavLink>
                                <NavLink to={"/merge-live-table/"+id} className={(e)=> ` w-[100px] h-[40px] absolute left-[240px] bg-color1 text-color4 text-center p-1 border-color3 border-x border-t ${e.isActive? " h-[42px]":"h-[40px]"} rounded-sm `}>Merge Table</NavLink>
                                <NavLink to={"/separate-live-table/"+id} className={(e)=> ` w-[120px] h-[40px] absolute left-[360px] bg-color1 text-color4 text-center p-1 border-color3 border-x border-t ${e.isActive? " h-[42px]":"h-[40px]"} rounded-sm `}>Separate Table</NavLink>
                            </div>

                            <div className=" w-[50%] flex items-center">
                                <h1 className=" text-xl text-color4 uppercase font-semibold">Room {id}</h1>
                            </div>

                        </div>

                        <div className=" w-full h-full border-t border-color3 ">
                            {
                                componentList.map((data, index)=>{
                                    return(
                                        <DraggAbleComponentView key={index} data={data} />
                                    )
                                })
                            }
                        </div>

                    </div>
                    <div className=" w-[24%] h-full bg-color2 p-2 ">
                        <h2 className=" pb-2 text-center uppercase font-semibold text-color6 border-b border-color6">Separate Table</h2>
                        <div className=" p-10 text-lg flex flex-col gap-4">
                            {
                                mergeList.map((data)=>{
                                    return(
                                        <div key={data?.id} className=" flex items-center justify-between">
                                            <span className=" text-color4">{data?.name}</span>
                                            <button onClick={()=>separate(data)} className=" px-2 py-1 bg-color6 rounded-md"> Separate</button>
                                        </div>
                                    )
                                })
                            }
                            
                        </div>
                    </div>
                    
                </div>
            </Layout>
        </div>
    )
}

export default SeparateTable;

